import {call, put, select} from "redux-saga/effects";
import {
  resetBlogTabs, setBlogDetails, setBlogPublished,
  setBlogs, setBlogTags, setBlogTagsCreating,
  setCurrentPage,
  setManageBlogModals,
  updateBlogTabData
} from "../../slices/manageBlogSlice";
import {BLOG_STATE_ACTIVE, BLOG_STATE_DRAFT, BLOG_TAB_TAGS, MAX_TAGS_ALLOWED} from "../../../pages/blogs/constants";
import {
  deleteBlogTags,
  getAllBlogs,
  getAllTags, getBlog, patchBlogs,
  postBlogs, postBlogTags,
  postOrPutBlogTags
} from "../requests/blogService";
import {setLoading as setDynamicLoading} from "../../slices/dynamicElementsSlice";
import {toast} from "react-toastify";
import {toKebabCase} from "../../../helpers/helperFunctions";
import {resetAllSearch} from "../../slices/searchSlice";


export function* handleGetBlogs(action) {
  const selectedTab = action.payload?.type ?? (yield select((state) => state.manageBlogs.selectedTab));
  try {

    let currentPage = action.payload?.page ?? 1;

    const storedData = yield select((state) => state.manageBlogs[selectedTab].pageData[currentPage]);

    if (storedData?.init) {
      yield put(setCurrentPage({page: currentPage, type: selectedTab}));
    } else {
      yield put(setBlogs({loading: true, page: currentPage, type: selectedTab}));

      const {
        data: {
          data,
          total_pages: totalPages,
          page
        }
      } = yield call(() => selectedTab === BLOG_TAB_TAGS ? getAllTags(currentPage) : getAllBlogs(currentPage, selectedTab));

      yield put(setBlogs({data, totalPages, page, type: selectedTab}));

    }

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    yield put(setBlogs({error: errorMsg, type: selectedTab}));
  }
}

export function* handleGetBlogDetail(action) {
  try {

    if (action.payload.clear) {
      yield put(setBlogDetails({clear: true}));
    } else {

      yield put(setBlogDetails({loading: true}));

      const {
        data
      } = yield call(() => getBlog(action.payload.id));

      yield put(setBlogDetails({data}));

    }

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    yield put(setBlogDetails({error: errorMsg}));
  }
}

export function* handleAddOrUpdateBlogTags(action) {
  const element = "editing";
  try {
    yield put(setDynamicLoading({loading: true, element}));
    const {data: isEdit} = yield select((state) => state.manageBlogs.modals.tagCrud);

    const {data} = yield call(() => postOrPutBlogTags(isEdit?.id, action.payload));

    if (isEdit) {
      yield put(updateBlogTabData({data, type: BLOG_TAB_TAGS}));

      toast.success("Tags Updated Successfully");

    } else {
      yield put(resetBlogTabs({tags: true}));
      toast.success('Tags Added Successfully.');
    }

    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageBlogModals());

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

export function* handleAddTagsAndUpdateInBlog(action) {
  try {

    const tags = yield select((state) => state.manageBlogs.create.tags);

    if (tags.length >= MAX_TAGS_ALLOWED) {
      toast.error(`Max ${MAX_TAGS_ALLOWED} tags are allowed to be added in a blog.`);
    } else {

      yield put(setBlogTagsCreating({loading: true, data: action.payload.title}));

      const {data} = yield call(() => postBlogTags(action.payload));


      yield put(setBlogTagsCreating({clear: true}));
      yield put(resetAllSearch());
      yield put(resetBlogTabs({tags: true}));
      yield put(setBlogTags({tag: data}));
      toast.success('Tags Added Successfully.');
    }

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setBlogTagsCreating({clear: true}));
  }
}

export function* handleAddNewBlog(action) {
  const element = "editing";
  try {

    const {content, tags, data: meta, mainTitle} = yield select((state) => state.manageBlogs.create);

    yield put(setDynamicLoading({loading: true, element}));

    const {data} = yield call(() => postBlogs({
      title: mainTitle?.trim(),
      seo_details: {
        ...meta.seoDetails,
        slug: meta.seoDetails.slug?.trim() ? toKebabCase(meta.seoDetails.slug?.trim()) : toKebabCase(meta.seoDetails.title),
        description: meta.seoDetails.description.trim(),
        title: meta.seoDetails.title.trim()
      },
      data: {...content, time: new Date().getTime()},
      state: action.payload.publish ? BLOG_STATE_ACTIVE : BLOG_STATE_DRAFT,
      tags: tags.map((tag) => tag.id)

    }));
    // yield put(resetBlogTabs({tags: true}));
    toast.success('Blog Added Successfully.');

    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageBlogModals());
    yield put(setBlogPublished());
    //todo handle load

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

export function* handleUpdateBlogContents(action) {
  const element = "editing";
  try {
    yield put(setDynamicLoading({loading: true, element}));
    // const {content, tags, data: meta} = yield select((state) => state.manageBlogs.create);

    const {data: values, modal: isConfirm} = yield select((state) => state.manageBlogs.modals.confirmBlog);
    let reqId, reqData = {};
    if (isConfirm) {
      reqData = {
        state: values.state
      };
      reqId = values.blog.id;
    } else {
      const {data: form} = yield select((state) => state.manageBlogs.modals.form);
      const {data: meta, tags, content, mainTitle} = yield select((state) => state.manageBlogs.create);
      const fromUpdateMetaData = !Object.keys(content).length
      reqData = {
        seo_details: {...meta.seoDetails, slug: form.seo_details.slug},
        tags: tags.map((tag) => tag.id),

        ...(!fromUpdateMetaData && {data: content}),
        ...(!fromUpdateMetaData && {title: mainTitle?.trim()}),
        ...(!!action.payload.state && {state: action.payload.state})
      };
      reqId = form.id;
    }


    const {data} = yield call(() => patchBlogs(reqId, reqData));

    if (values?.state) {
      toast.success('Successfully Updated blog\'s status.');
      yield put(resetBlogTabs({active: true, inactive: true, draft: true, selectedTab: values.state}));
    } else {
      const blogContents = yield select((state) => state.manageBlogs.create.content);

      if (Object.keys(blogContents).length) {
        yield put(setBlogPublished());
        toast.success('Successfully updated the blog.');
      } else {
        if (action.payload.state) {
          yield put(resetBlogTabs({active: true, inactive: true, draft: true, selectedTab: action.payload.state}));
        } else {
          yield put(updateBlogTabData({data}));
        }


        toast.success('Successfully Updated blog\'s meta data.');
      }


    }


    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageBlogModals());


  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

export function* handleDeleteBlogTag() {
  const element = "editing";
  try {
    yield put(setDynamicLoading({loading: true, element}));
    const {data: tag} = yield select((state) => state.manageBlogs.modals.confirm);

    yield call(() => deleteBlogTags(tag?.delete?.id));

    yield put(resetBlogTabs({tags: true}));

    yield put(setDynamicLoading({loading: false, element}));
    yield put(setManageBlogModals());

    toast.success('Successfully deleted the tag.');

  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message;
    toast.error(`Error: ${errorMsg}`);
    yield put(setDynamicLoading({loading: false, element}));
  }
}

